export default __webpack_public_path__ + "static/media/1 Pereanaliticheskie trebovania k vzyatiu biologicheskogo materiala.399ecfaa.pdf";